import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container mob-flex-direction position-relative flex-column page_hero" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "container__wrapper col-sm-12 col-md-6 col-lg-7 flex-column" }
const _hoisted_4 = { id: "container__heading_main" }
const _hoisted_5 = { class: "h3 -font h3-font container__heading" }
const _hoisted_6 = { class: "container__wrapper col-sm-12 col-md-6 col-lg-7 flex-column d-flex page_hero_bottom" }
const _hoisted_7 = { class: "serviceTypeButtons align-items-center align-items-md-start" }
const _hoisted_8 = { class: "serviceType with_driver_option" }
const _hoisted_9 = {
  class: "ml-5",
  for: "withDriver"
}
const _hoisted_10 = {
  class: "ml-5",
  for: "roundTrip"
}
const _hoisted_11 = { class: "container d-flex mob-flex-direction position-relative flex-column main-service" }
const _hoisted_12 = { class: "start-0 w-100 formComponent mt-lg-4 mt-md-3 mt-sm-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_CheckBoxComponent = _resolveComponent("CheckBoxComponent")!
  const _component_RentComponent = _resolveComponent("RentComponent")!
  const _component_TransportationComponent = _resolveComponent("TransportationComponent")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('minibus_rental')), 1),
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('passenger_transportation')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ButtonComponent, {
            id: "rentButton",
            class: _normalizeClass(["typeButtons me-lg-3", [_ctx.serviceType === _ctx.ServiceTypes.SERVICE_RENT ? 'active' : null]]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onServiceTypeChange(_ctx.ServiceTypes.SERVICE_RENT)))
          }, {
            btnContent: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('minibus_rental')), 1)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_ButtonComponent, {
            id: "transportationButton",
            class: _normalizeClass(["typeButtons", [_ctx.serviceType === _ctx.ServiceTypes.SERVICE_TRANSPORTATION ? 'active' : null]]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onServiceTypeChange(_ctx.ServiceTypes.SERVICE_TRANSPORTATION)))
          }, {
            btnContent: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('passenger_transportation')), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_ctx.serviceType === _ctx.ServiceTypes.SERVICE_RENT)
            ? (_openBlock(), _createBlock(_component_CheckBoxComponent, {
                key: 0,
                onOnClick: _ctx.isWithDriver,
                state: _ctx.withDriver,
                id: 'withDriver',
                name: "withDriver",
                class: "checkbox-default"
              }, {
                "checkbox-text": _withCtx(() => [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('minibus_rent_with_driver')), 1)
                ]),
                _: 1
              }, 8, ["onOnClick", "state"]))
            : _createCommentVNode("", true),
          (_ctx.serviceType === _ctx.ServiceTypes.SERVICE_TRANSPORTATION)
            ? (_openBlock(), _createBlock(_component_CheckBoxComponent, {
                key: 1,
                onOnClick: _ctx.isRoundTrip,
                state: _ctx.roundTrip,
                id: 'roundTrip',
                name: "roundTrip",
                class: "checkbox-default"
              }, {
                "checkbox-text": _withCtx(() => [
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('round_trip')), 1)
                ]),
                _: 1
              }, 8, ["onOnClick", "state"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.serviceType === _ctx.ServiceTypes.SERVICE_RENT)
            ? (_openBlock(), _createBlock(_component_RentComponent, {
                key: 0,
                "with-driver": _ctx.withDriver
              }, null, 8, ["with-driver"]))
            : _createCommentVNode("", true),
          (_ctx.serviceType === _ctx.ServiceTypes.SERVICE_TRANSPORTATION)
            ? (_openBlock(), _createBlock(_component_TransportationComponent, {
                key: 1,
                "round-trip": _ctx.roundTrip
              }, null, 8, ["round-trip"]))
            : _createCommentVNode("", true)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-5" }, null, -1))
      ])
    ])
  ]))
}